import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    EmailGesendetTableColumn,
    KieneBooleanTableColumn,
    PdfTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { HttpParams } from '@angular/common/http';
import { TableOption } from '../../components/kiene-table/table-option';

import { Bestandsbesuchprotokoll } from './bestandsbesuchsprotokoll';
import { ConfirmDeleteDialogComponent } from '../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { Subscription } from 'rxjs';
import { TabinfoService } from '../../components/tabinfo/tabinfo.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';

@Component({
    selector: 'kiene-bestandsbesuchsprotokoll',
    templateUrl: './bestandsbesuchsprotokoll.component.html',
    styleUrls: ['./bestandsbesuchsprotokoll.component.scss'],
})
export class BestandsbesuchsprotokollComponent implements OnInit, OnDestroy {
    tableDescriptor: TableDescriptor = new TableDescriptor();
    currentClient: Client;
    watchClientSubscription: Subscription;

    constructor(
        public dialog: MatDialog,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly messageService: MessageService,
        private readonly localStorageService: LocalStorageService,
        private tableService: KieneTableService,
        private readonly pdfService: PdfViewerDesktopService,
        private readonly api: KieneTableService,
        private readonly tabinfoService: TabinfoService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.currentClient = this.localStorageService.getCurrentClient();

        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe(response => {
            if (response) {
                this.currentClient = response;
                this.tableDescriptor.createAllowed = true;
                const kundeId: string = this.currentClient.kunde_id.toString();
                this.tableDescriptor.params = new HttpParams().set('kunde_id', kundeId);
                this.tableService.reload();
            } else {
                this.tableDescriptor.createAllowed = true;
                this.tableDescriptor.params = null;
                this.tableService.reload();
            }
        });

        this.tableService.watchDataLoadedCompleted().subscribe({
            next: () => {
                this.tabinfoService.setReload('bestandsbesuchsprotokoll/tabinfo.php');
            },
        });

        if (this.currentClient) {
            const kundeId: string = this.currentClient.kunde_id.toString();
            this.tableDescriptor.params = new HttpParams().set('kunde_id', kundeId);
            this.tableDescriptor.createAllowed = true;
        } else {
            this.tableDescriptor.createAllowed = true;
        }

        this.tableDescriptor.headline = 'Bestandsbesuchsprotokolle';
        this.tableDescriptor.uniqueIdentifier = 'Bestandsbesuchsprotokolle';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'bestandsbesuchsprotokoll/';
        this.tableDescriptor.route = '/belege/bestandsbesuch/';
        this.tableDescriptor.nameOfIdField = 'bbp_id';
        this.tableDescriptor.searchPlaceholder = 'Bestandsbesuchsprotokolle durchsuchen';

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('bbp_id', 'Nr.'));
        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('datum', 'Datum', 'date'));
        this.tableDescriptor.columns.push(new TableColumn('status', 'Status'));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('abgabebeleg_id', 'Abgerechnet'));
        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.openPdf.bind(this)));
        this.tableDescriptor.columns.push(new EmailGesendetTableColumn());
        // this.tableDescriptor.columns.push(new GedrucktTableColumn());

        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'löschen', 'delete', 3854));
        this.tableDescriptor.options.push(new TableOption(this.duplicate.bind(this), 'duplizieren', 'file_copy', 3855));
        // this.tableDescriptor.options.push(
        //     new TableOption(null, 'Drucken', 'print', 3858, { conditions: [new Condition('pdf_id', Operator.EXISTIERT, null)], void: this.gedruckt.bind(this) })
        // );

        this.tableDescriptor.permissionView = 3851;
        this.tableDescriptor.permissionCreate = 3852;

        this.tableDescriptor.initialSortColumn = 'datum';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.addVoid = this.gotoNeu.bind(this);
    }

    gedruckt(bbp: Bestandsbesuchprotokoll) {
        this.api
            .get(this.apiBaseUrl + 'bestandsbesuchsprotokoll/gedruckt.php', new HttpParams().set('bbp_id', bbp.bbp_id))
            .subscribe({
                next: () => {
                    this.tableService.reload('gedruckt');
                    this.openPdf(bbp);
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                },
            });
    }

    ngOnDestroy() {
        this.watchClientSubscription.unsubscribe();
        this.tableService = null;
    }

    openPdf(bbp: Bestandsbesuchprotokoll) {
        const input = new PdfViewerDialogInput(
            'bestandsbesuchsprotokoll/read_or_mail_pdf.php',
            new HttpParams().set('bbp_id', bbp?.bbp_id?.toString()),
            'Bestandsbesuchsprotokoll ' + bbp?.bbp_id?.toString(),
            { email: { sende_mail: true, kunde_id: bbp?.kunde_id } },
        );
        this.pdfService.openPdfViewer(input).subscribe({
            next: () => {
                this.api.reload();
            },
        });
    }

    gotoDetails(bbp: Bestandsbesuchprotokoll) {
        if (this.localStorageService.currentUserHasPermission(3853)) {
            this.router.navigate([bbp.bbp_id], { relativeTo: this.route });
        } else {
            this.openPdf(bbp);
        }
    }

    gotoNeu() {
        if (this.localStorageService.getCurrentClient()) {
            this.router.navigate(['belege', 'bestandsbesuch', 'neu']);
            return;
        }
        this.changeCurrentClientService.openChangeDialog().subscribe(client => {
            if (client) {
                this.router.navigate(['belege', 'bestandsbesuch', 'neu']);
            } else {
                this.messageService.alertMessage(
                    'Bitte zuerst einen Betrieb auswählen, um ein Bestandsbesuchsprotokoll anzulegen.',
                );
            }
        });
    }

    duplicate(bbp: Bestandsbesuchprotokoll) {
        this.api.duplicateEntity(this.apiBaseUrl + 'bestandsbesuchsprotokoll/duplicate.php', bbp).subscribe(
            response => {
                this.messageService.infoMessage('Das Bestandsbesuchsprotokoll wurde erfolgreich dupliziert!');
                this.router.navigate(['belege', 'bestandsbesuch', response.bbp_id]);
            },
            error => {
                this.messageService.errorMessage('Der Maßnahmenplan konnte nicht dupliziert werden!', error);
            },
        );
    }

    openDeleteDialog(bbp: Bestandsbesuchprotokoll) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
            width: '500px',
            data: {
                title: 'Bestandsbesuchprotokoll wirklich löschen?',
                text: 'Bestandsbesuchprotokoll wirklich löschen?',
            },
        });

        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                this.api.deleteEntity(this.apiBaseUrl + 'bestandsbesuchsprotokoll/delete.php', bbp).subscribe(
                    () => {
                        this.messageService.infoMessage('Das Bestandsbesuchprotokoll wurde erfolgreich gelöscht!');
                        this.tableService.reload();
                    },
                    error => {
                        this.messageService.errorMessage(
                            'Das Bestandsbesuchprotokoll konnte nicht gelöscht werden! ',
                            error,
                        );
                    },
                );
            }
        });
    }
}
